'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = require('lodash');

var _ = _interopRequireWildcard(_lodash);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 *  recursively traverses a provided object, redacting values based on
 *  an array of object keys
 */
var KeysFilter = function () {

    /**
     *
     * @param keysArray: array of keys that need their values redacted
     */
    function KeysFilter(keysArray) {
        _classCallCheck(this, KeysFilter);

        this.keysArray = keysArray;
        this.filtered = '*****';
        this.missing = "";
    }

    /**
     * recursively traverses a provided object, redacting values based on
     * an array of object keys.
     * @param {object} dataObject: object that needs values filtered out
     * @returns {object} filtered/redacted version of data param. 
     */


    _createClass(KeysFilter, [{
        key: 'doFilter',
        value: function doFilter(dataObject) {

            var filtered = this._replaceValuesOfNestedKeys(dataObject);
            return filtered;
        }

        /**
         * currently recursively filters object per key. 
         * It might be worth looking at inverting this, traversing the object 
         * just once and checking each key against the keyArray
         * 
         * @param {object} object: object that needs values filtered out
         * @returns {object} filteredCopy of object param, with values redacted as needed
         * @private
         */

    }, {
        key: '_replaceValuesOfNestedKeys',
        value: function _replaceValuesOfNestedKeys(object) {
            // this will be passed around and operated on directly.        
            var filteredCopy = _.cloneDeep(object);

            for (var index in this.keysArray) {
                this._replaceByKey(filteredCopy, this.keysArray[index]);
            }
            return filteredCopy;
        }

        /*
        refactored recursive method
         */
        /**
         * mediator for recursively processing the passed object.
         *
         * @param {object} object: object to redact/filter
         * @param {string} key: key that requires it's values redacted
         * @returns {object} return the object param, with values redacted for the provided key
         * @private
         */

    }, {
        key: '_replaceByKey',
        value: function _replaceByKey(object, key) {

            if (Array.isArray(object)) {
                return this._processArray(object, key);
            } else {
                return this._processProps(object, key);
            }
        }

        /**
         * part of the recursive processing.
         * iterates over an array, recursively processing each individual component
         * 
         * @param {Array || object} anArray: array to process
         * @param {string} key: key that requires it's values redacted
         * @returns {array} array of objects, redacted as required
         * @private
         */

    }, {
        key: '_processArray',
        value: function _processArray(anArray, key) {
            var result = [];
            for (var i = 0; i < anArray.length; i++) {
                // recursive call back to _replaceByKey
                result.push(this._replaceByKey(anArray[i], key));
            }
            // array has now been fully processed and filtered. 
            return result;
        }

        /**
         * part of the recursive processing.
         * iterates over all props of object, redacting any that match the provided key.
         * if the prop is another object, continues recursive call
         * 
         * @param {object} object: object to process
         * @param {string} key: key that requires it's values redacted
         * @returns {Object} object with values redacted as required
         * @private
         */

    }, {
        key: '_processProps',
        value: function _processProps(object, key) {
            for (var prop in object) {
                if (prop === key) {
                    // we found the key, so replace the value with '*****' if value is present
                    // or with an empty string if null, undefined, or empty string
                    object[prop] = this._isValueEmpty(object[prop]) ? this.missing : this.filtered;
                }
                /*
                instanceof Object does not work here, even thought it worked for unit tests. instanceof
                tests for the constructor used, and it's returning false for Object.  I have been unable 
                to create a test to duplicate this problem
                 */

                if (_typeof(object[prop]) === 'object') {
                    // recursive call back to _replaceByKey
                    object[prop] = this._replaceByKey(object[prop], key);
                }
            }
            // object has now been fully processed and filtered. 
            return object;
        }
    }, {
        key: '_isValueEmpty',
        value: function _isValueEmpty(value) {
            return value === null || typeof value === 'undefined' || value === "";
        }
    }]);

    return KeysFilter;
}();

exports.default = KeysFilter;


//////////////////
// WEBPACK FOOTER
// ./node_modules/wendys-kenny-loggins-filtering-appender/lib/KeysFilter.js
// module id = 892
// module chunks = 0